import { Link } from 'react-router-dom';

const BOOKS = [
  { id: 'genesis', name: 'Génesis' },
  { id: 'exodo', name: 'Éxodo' },
  { id: 'levitico', name: 'Levítico' },
  { id: 'numeros', name: 'Números' },
  { id: 'deuteronomio', name: 'Deuteronomio' },
  { id: 'josue', name: 'Josué' },
  { id: 'jueces', name: 'Jueces' },
  { id: 'rut', name: 'Rut' },
  { id: '1-samuel', name: '1 Samuel' },
  { id: '2-samuel', name: '2 Samuel' },
  { id: '1-reyes', name: '1 Reyes' },
  { id: '2-reyes', name: '2 Reyes' },
  { id: '1-cronicas', name: '1 Crónicas' },
  { id: '2-cronicas', name: '2 Crónicas' },
  { id: 'esdras', name: 'Esdras' },
  { id: 'nehemias', name: 'Nehemías' },
  { id: 'ester', name: 'Ester' },
  { id: 'job', name: 'Job' },
  { id: 'salmos', name: 'Salmos' },
  { id: 'proverbios', name: 'Proverbios' },
  { id: 'eclesiastes', name: 'Eclesiastés' },
  { id: 'cantares', name: 'Cantares' },
  { id: 'isaias', name: 'Isaías' },
  { id: 'jeremias', name: 'Jeremías' },
  { id: 'lamentaciones', name: 'Lamentaciones' },
  { id: 'ezequiel', name: 'Ezequiel' },
  { id: 'daniel', name: 'Daniel' },
  { id: 'oseas', name: 'Oseas' },
  { id: 'joel', name: 'Joel' },
  { id: 'amos', name: 'Amos' },
  { id: 'abdias', name: 'Abdías' },
  { id: 'jonas', name: 'Jonás' },
  { id: 'miqueas', name: 'Miqueas' },
  { id: 'nahum', name: 'Nahum' },
  { id: 'habacuc', name: 'Habacuc' },
  { id: 'sofonias', name: 'Sofonías' },
  { id: 'hageo', name: 'Hageo' },
  { id: 'zacarias', name: 'Zacarías' },
  { id: 'malaquias', name: 'Malaquías' },
  { id: 'mateo', name: 'Mateo' },
  { id: 'marcos', name: 'Marcos' },
  { id: 'lucas', name: 'Lucas' },
  { id: 'juan', name: 'Juan' },
  { id: 'hechos', name: 'Hechos' },
  { id: 'romanos', name: 'Romanos' },
  { id: '1-corintios', name: '1 Corintios' },
  { id: '2-corintios', name: '2 Corintios' },
  { id: 'galatas', name: 'Gálatas' },
  { id: 'efesios', name: 'Efesios' },
  { id: 'filipenses', name: 'Filipenses' },
  { id: 'colosenses', name: 'Colosenses' },
  { id: '1-tesalonicenses', name: '1 Tesalonicenses' },
  { id: '2-tesalonicenses', name: '2 Tesalonicenses' },
  { id: '1-timoteo', name: '1 Timoteo' },
  { id: '2-timoteo', name: '2 Timoteo' },
  { id: 'tito', name: 'Tito' },
  { id: 'filemon', name: 'Filemón' },
  { id: 'hebreos', name: 'Hebreos' },
  { id: 'santiago', name: 'Santiago' },
  { id: '1-pedro', name: '1 Pedro' },
  { id: '2-pedro', name: '2 Pedro' },
  { id: '1-juan', name: '1 Juan' },
  { id: '2-juan', name: '2 Juan' },
  { id: '3-juan', name: '3 Juan' },
  { id: 'judas', name: 'Judas' },
  { id: 'apocalipsis', name: 'Apocalipsis' },
];

const oldTestament = BOOKS.slice(0, 39);
const newTestament = BOOKS.slice(39);

export default function Bible() {
  return (
    <div className="min-h-screen pb-4" style={{ backgroundColor: '#1C1C1E' }}>
      <div className="px-4 pt-2 pb-4">
        <h1 className="text-2xl font-bold text-white">Biblia</h1>
        <p className="text-sm" style={{ color: '#4A90D9' }}>Reina Valera 1960</p>
      </div>

      <section className="px-4 mb-6">
        <h2 className="text-xs font-bold uppercase tracking-widest mb-3" style={{ color: '#8E8E93' }}>Antiguo Testamento</h2>
        <div className="grid grid-cols-2 gap-2">
          {oldTestament.map((book) => (
            <Link
              key={book.id}
              to={`/bible/${book.id}`}
              className="py-3 px-4 rounded-md text-center text-white text-sm font-medium active:opacity-70 transition-opacity"
              style={{ backgroundColor: '#2C2C2E' }}
            >
              {book.name}
            </Link>
          ))}
        </div>
      </section>

      <section className="px-4">
        <h2 className="text-xs font-bold uppercase tracking-widest mb-3" style={{ color: '#8E8E93' }}>Nuevo Testamento</h2>
        <div className="grid grid-cols-2 gap-2">
          {newTestament.map((book) => (
            <Link
              key={book.id}
              to={`/bible/${book.id}`}
              className="py-3 px-4 rounded-md text-center text-white text-sm font-medium active:opacity-70 transition-opacity"
              style={{ backgroundColor: '#2C2C2E' }}
            >
              {book.name}
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
